<template>
  <AuthForm />
</template>
<script setup lang="ts">
  useHead({ title: 'Sign Up | Yogen' })
</script>
